<template>
  <o-sales-view
    nav-bar-title="Velo jaarkaart"
    title="Velo jaarkaart"
    image="images/velo-header.jpg"
    :points="3"
    :show-budgets="false"
    price="49,00"
    message="Hier komt wat uitleg over de Velo jaarkaart."
    next-link="/sales/bike/velo-abo/confirmation"
  >
    <o-section>
      <o-text-input
        label="Startdatum abonnement"
        type="date"
        value="2020-02-13"
        icon="date"
      />
    </o-section>
    <o-section>
      <o-tab-switch name="reason" :items="['Werk', 'Woon-werk', 'Privé']" />
    </o-section>
  </o-sales-view>
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
import OTabSwitch from '@/components/base/OTabSwitch.vue'
import OTextInput from '@/components/base/OTextInput.vue'
export default {
  name: 'VeloAbo',
  components: {
    OTextInput,
    OTabSwitch,
    OSalesView
  }
}
</script>
